import React, { FC, ReactNode } from 'react';
import { IconTwoLine, Item, ItemProps, Text } from '@cld/item';
import { asStyledComponent } from '@cld/component-enhancer';
import { mergeCallbacks } from '../../utils/mergeCallbacks';
import { useListSelection } from './ListSelectionProvider';
import { useListVariant } from './ListVariantProvider';

const useListItemProps = (id: string, { role = 'listitem', onClick, ...rest }: ItemProps) => {
  const listContext = useListVariant();
  const { onClick: useListSelectionOnClick, ...selectionContext } = useListSelection(id);

  return { 'data-id': id, role, ...listContext, ...selectionContext, ...rest, onClick: mergeCallbacks(onClick, useListSelectionOnClick) };
};

export const DefaultListItem = asStyledComponent<FC<ItemProps & { id: string }>>(({ id, children, ...rest }) => {
  const props = useListItemProps(id, rest);
  return <Item {...props}>{children}</Item>;
});

const TextListItem = asStyledComponent<FC<ItemProps & { id: string }>>(({ id, children, ...rest }) => {
  const props = useListItemProps(id, rest);
  return (
    <Item {...props}>
      <Text>{children}</Text>
    </Item>
  );
});

const IconTwoLineItem = asStyledComponent<
  FC<ItemProps & { id: string } & { icon?: ReactNode; primaryText?: ReactNode; secondaryText?: ReactNode; actions?: ReactNode }>
>(({ id, children, icon, primaryText, secondaryText, actions, ...rest }) => {
  const props = useListItemProps(id, rest);
  return (
    <Item {...props}>
      <IconTwoLine {...{ icon, primaryText, secondaryText, actions }} />
    </Item>
  );
});
export const ListItem = {
  // todo ermove, use item layout directly
  Default: DefaultListItem,
  Text: TextListItem,
  IconTwoLine: IconTwoLineItem,
};
